

import React from 'react';
import PortfolioPage from 'views/PrabhatPheri';

const PortfolioViewPage = () => {
  return <PortfolioPage />;
};

export default PortfolioViewPage;